import {Button, Stack, Typography, useTheme} from '@mui/material';
import {AlertModal} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {HandleMessage} from 'presentation/components/HandleMessage';
import {ModalSuccessProps} from './types';
import {SendMessagePageEnum} from '../../../../../../../tests/constants/HelpPageEnum';

const {
	modalSuccess: {titleModal, title, description, buttonGoBack, protocol},
} = translations['pt-br'].privateFlow.help.sendYourMessage;

export function ModalSuccess({open, onBack, protocolValue}: ModalSuccessProps) {
	const theme = useTheme();
	return (
		<AlertModal
			data-testid={SendMessagePageEnum.SEND_MESSAGE_SUCCESSFULLY}
			open={open}
			onClose={onBack}
			variant="success"
			headerTitle={titleModal}
			title={title}
		slotProps={{
			paper: {
				style: {
					maxWidth: 420,
				},
			},
		}}
			subDescription={
				<Stack justifyContent={'center'} alignItems={'center'} gap={2}>
					<Typography variant="body2" textAlign={'center'}>
						<HandleMessage message={description} />
					</Typography>
					<Stack direction={'row'} gap={1}>
						<Stack pt={0.5}>
							<Icon
								name="assignment-filled"
								color={theme.colors.brand.primary.blue}
								size={16}
							/>
						</Stack>
						<Stack>
							<Typography
								fontSize={'0.875rem'}
								fontWeight={400}
								color={'text.secondary'}>
								{protocol}
							</Typography>
							<Typography>{protocolValue}</Typography>
						</Stack>
					</Stack>
				</Stack>
			}
			footerContent={
				<Stack width={'100%'}>
					<Button onClick={onBack} size="large">
						{buttonGoBack}
					</Button>
				</Stack>
			}
		/>
	);
}
